/***
 * Created on 2023/8/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import {useEffect, useRef, useState} from "react";


export function useTogglePopup(options={pinContent:false}) {
    const elemRef = useRef();
    const [isShow, setIsShow] = useState(false);

    const hideElement = (e) => {
        if (elemRef.current && !elemRef.current.contains(e.target)) {
            setIsShow(false);
        }
    }

    const toggleAction = (e) => {
        if (options?.pinContent) {
            if (elemRef.current.isSameNode(e.target)) {
                setIsShow(prev => !prev);
            }
        }
        else{
            setIsShow(prev => !prev);
        }
    }

    useEffect(() => {
        window.addEventListener('click', hideElement);

        return () => {
            window.removeEventListener('click', hideElement)
        }
    });

    return {isShow, toggleAction, elemRef, setIsShow}
}